<div class="container">
  <div class="mb-3">
    <ds-vocabulary-treeview [vocabularyOptions]=vocabularyOptions
                            [multiSelect]="true"
                            (select)="onSelect($event)"
                            (deselect)="onDeselect($event)">
    </ds-vocabulary-treeview>
  </div>
  <a class="btn btn-primary"
     [routerLink]="['/search']"
     [queryParams]="queryParams"
     [queryParamsHandling]="'merge'">
    {{ 'browse.taxonomy.button' | translate }}</a>
</div>
